import type { Simplify, ValueOf } from 'type-fest';

export enum BannerStyle {
  Low = 'low', // TODO: refactor 'low' -> 'info'
  Medium = 'medium', // TODO: refactor 'medium' -> 'warning'
  High = 'high', // TODO: refactor 'high' -> 'danger'
  Success = 'success',
  Info = 'info',
}

export enum BannerSize {
  Small = 'small',
  Medium = 'medium'
}

export enum BannerAttention {
  Low = 'low',
  High = 'high'
}

export enum BannerScope {
  Global = 'global',
  Organizations = 'organizations',
}

export enum BannerPlacement {
  Login = 'login',
  Dashboard = 'dashboard',
  All = 'all',
}

export enum RevisionScanType {
  Project = 'project',
  Release = 'release',
}

export enum RevisionCliLicenseScanType {
  MatchData = 'match_data',
  FullFiles = 'full_files',
}

export enum IssueStatusScope {
  Project = 'project',
  ReleaseGroup = 'release_group',
}

export enum IssueResolutionScope {
  Global = 'global',
  Project = 'project',
  ReleaseGroup = 'release_group',
}

export enum ReportRenderer {
  EJS = 'ejs',
  SWIG = 'swig'
}

export enum Reports {
  HTML = 'HTML',
  PLAINTEXT = 'TXT',
  CSV = 'CSV',
  PDF = 'PDF',
  JSON = 'JSON',
  MARKDOWN = 'MD',
  SPDX = 'SPDX',
  SPDX_JSON = 'SPDX_JSON',
  CYCLONEDX_JSON = 'CYCLONEDX_JSON',
  CYCLONEDX_XML = 'CYCLONEDX_XML',
}

export enum FailedActionType {
  Build = 'build',
}

export enum RoleScope {
  Organization = 'organization',
  Team = 'team',
}

export enum SocialLoginPlatform {
  GitHub = 'github',
  BitbucketCloud = 'bitbucket_cloud',
  GitLab = 'gitlab',
  Google = 'google',
}

export enum OrganizationSsoMethod {
  Google = 'google',
  SAML = 'saml',
  LDAP = 'ldap',
}

export enum RawVulnStatus {
  priority = 'priority',
  review = 'review',
  new = 'new',
  complete = 'complete',
  disabled = 'disabled',
}

export enum CVEStatus {
  Disputed = 'DISPUTED',
  Reserved = 'RESERVED',
  Rejected = 'REJECT',
  InReview = 'IN_REVIEW',
  Completed = 'COMPLETED',
}

export const ProjectSource = {
  Archive: 'archive',
  Autobuild: 'autobuild',
  Container: 'container',
  CycloneDX: 'cyclonedx',
  Package: 'package',
  SBOM: 'sbom',
  Binary: 'binary',
  Provided: 'provided', // TODO: update this to comply with the updated naming convention of CLI Upload CORE-3583
} as const;

export type ProjectSources = ValueOf<typeof ProjectSource>;

export type ProjectType = Simplify<ValueOf<
  Omit<typeof ProjectSource, 'CycloneDX' | 'Package'>
> | null>;

export enum PolicyType {
  LICENSING = 'LICENSING',
  SECURITY = 'SECURITY',
  QUALITY = 'QUALITY',
  SBOM = 'SBOM',
}

export enum RevisionSource {
  GitHub = 'github',
  GitLab = 'gitlab',
  Bitbucket = 'bitbucket',
  Azure = 'azure',
  CLI = 'cli',
  Archive = 'archive',
  Container = 'container',
  SBOM = 'sbom',
  Binary = 'binary',
}

export const AllRevisionSources = Object.values(RevisionSource);

export enum TeamType {
  Team = 'team',
  TeamGroup = 'team_group',
}
